// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SnackbarCenterWrapper[data-v-13264adc]{position:fixed;z-index:1000001;max-height:100vh;overflow-y:scroll;bottom:0;left:0}.transitionWrapper[data-v-13264adc]{display:flex;flex-direction:column;justify-content:flex-end}.elem-enter-active[data-v-13264adc],.elem-leave-active[data-v-13264adc]{transition:opacity .6s var(--trans-standart)}.elem-enter[data-v-13264adc],.elem-leave-to[data-v-13264adc]{opacity:0}", ""]);
// Exports
module.exports = exports;
